import { Stack, StackProps, styled } from '@mui/material';
import { COLOR_BG_BLACK } from 'shared';

export const BlackPlate = styled(Stack)<StackProps>(({ theme }) => ({
  backgroundColor: COLOR_BG_BLACK,
  width: '100%',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  borderRadius: theme.shape.borderRadius * 2,
  padding: theme.spacing(1, 1.5),
  gap: theme.spacing(1),
  overflow: 'hidden',
}));
